// extracted by mini-css-extract-plugin
module.exports = {"main_page":"Wallets_main_page__EY0-5","main_header":"Wallets_main_header__32zGH","content":"Wallets_content__2kh_s"};